<template>
  <div class="request-delete-account">
    <b-card class="delete-account">
      <img
        src="/img/request-delete-account.png"
        aspect-ratio="1"
        class="delete-account__image"
        width="189"
      />

      <h2 class="delete-account__title">
        {{ $t("delete_account.title") }}
      </h2>

      <div class="delete-account__note">
        <h4>{{ $t("delete_account.note.note") }}:</h4>
        <p>
          {{ $t("delete_account.note.description") }}
        </p>
      </div>

      <div class="delete-account__assurance">
        <p class="mb-1">
          {{ $t("delete_account.make_sure.delete_this_account_make_sure") }}:
        </p>
        <ul>
          <li>
            Rút hết số dư trong Tài khoản chính
          </li>
          <li>
            Rút hết số dư trong Tài khoản ký quỹ
          </li>
          <li>
            Hoàn thành các đơn hàng hiện tại
          </li>
        </ul>
      </div>

      <p class="delete-account__handled">
        {{
          $t(
            "delete_account.your_account_deletion_request_will_be_promptly_handled"
          )
        }}
      </p>

      <form>
        <b-field>
          <b-input
            v-model="description"
            type="textarea"
            :placeholder="
              $t('delete_account.before_you_go_please_let_us_know_the_reason')
            "
            autofocus
          ></b-input>
        </b-field>
        <b-button
          class="submit-btn"
          type="is-primary"
          :loading="isSubmiting"
          :disabled="submitButtonDisabled"
          @click="handleSubmit"
        >
          {{ $t("delete_account.submit_deletion_request") }}
        </b-button>
      </form>
    </b-card>

    <modal
      name="showResultDialog"
      :clickToClose="false"
      :width="364"
      :height="'auto'"
    >
      <div class="result-card">
        <h3 class="result-card__title">
          {{ $t("delete_account.submitted_your_request") }}
        </h3>
        <p class="result-card__description">
          {{ $t("delete_account.your_account_deletion_request") }}
        </p>
        <b-button class="done-btn" type="is-primary" @click="handleDoneClick">
          {{ $t("delete_account.close") }}
        </b-button>
      </div>
    </modal>
  </div>
</template>

<script>
import Vue from "vue";
import { mapGetters } from "vuex";
import VModal from "vue-js-modal";
import { createTicketV3 } from "../../store/api/api";
Vue.use(VModal);

export default {
  name: "RequestDeleteAccount",
  computed: {
    ...mapGetters(["supplierToken", "supplierProfile"]),
    submitButtonDisabled() {
      return !this.description.trim() || this.isSubmiting;
    },
  },
  data() {
    return {
      isSubmiting: false,
      isSuccessSubmit: false,
      description: "",
    };
  },
  methods: {
    handleSubmit() {
      if (!this.supplierProfile || !this.supplierToken) return;

      const params = {
        contact_reason: "request_account_deletion",
        description: this.description.trim(),
        subject: `Yêu cầu xoá thông tin dữ liệu và tài khoản - ${this.supplierProfile._id}`,
        service_channel: "Application store",
        sub_contact_reason: "request_account_deletion",
        user_id: this.supplierProfile._id,
        user_type: "supplier",
        token: this.supplierToken,
        type: "ahamove_others",
      };

      this.isSubmiting = true;
      this.$modal.show("showResultDialog");

      return new Promise((resolve, reject) => {
        createTicketV3(params)
          .then((response) => {
            if (response) {
              this.isSubmiting = false;
              this.isSuccessSubmit = true;
              this.$modal.show("showResultDialog");

              resolve(response);
            }
          })
          .catch((error) => {
            this.isSubmiting = false;
            this.isSuccessSubmit = false;

            this.$buefy.notification.open({
              message: error.message,
              type: "is-danger",
              duration: 3000,
              position: "is-bottom",
            });
            reject();
          });
      });
    },
    handleDoneClick() {
      this.$modal.hide("showResultDialog");
      this.description = "";
    },
  },
};
</script>

<style lang="scss" scoped>
.request-delete-account {
  height: 100vh;
  padding: 16px;
}

.delete-account {
  width: 100%;
  height: 100%;
  max-width: 585px;
  padding: 24px;
  background-color: #fff;

  &__image {
    display: block;
    margin: 0 auto;
    margin-bottom: 16px;
  }

  &__title {
    font-size: 24px;
    font-weight: 700;
    line-height: 32px;
    margin-bottom: 12px;
  }

  &__note {
    color: #f5222d;
    margin-bottom: 12px;

    p {
      font-size: 14px;
      line-height: 20px;
      font-weight: 500;
    }
  }

  &__assurance {
    margin-bottom: 12px;

    p {
      color: #4d5358;
      font-size: 14px;
      font-weight: 500;
      line-height: 20px;
    }

    ul {
      list-style-type: inherit;
      padding-left: 16px;
    }

    ul > li {
      font-size: 14px;
      font-weight: 700;
      line-height: 20px;
    }
  }

  &__handled {
    font-size: 14px;
    font-weight: 500;
    line-height: 20px;
    color: #4d5358;
    margin-bottom: 12px;
  }
}

.submit-btn {
  width: 100%;
  margin: 0;
}

.result-card {
  padding: 16px;
  border-radius: 4px;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.1);

  &__title {
    font-size: 18px;
    font-weight: bold;
    line-height: 24px;
    margin-bottom: 12px;
  }

  &__description {
    font-weight: 500;
    line-height: 20px;
    color: #4d5358;
    margin-bottom: 16px;
  }

  button {
    width: 100%;
  }
}

button {
  text-transform: none;
}

.vm--modal {
  height: auto;
}

@media screen and (min-width: 768px) {
  .request-delete-account {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  .delete-account {
    height: auto;
    border-radius: 16px;
    box-shadow: 0 16px 48px 0 rgba(0, 0, 0, 0.08);
  }
}
</style>
